/* Libs */
import { useHistory, useLocation } from 'react-router-dom';

/* Store */
import useModalStore from 'Stores/Modals';
import useDomStore from 'Stores/Dom';

/* Components */
import ModalHeader from './Header';
import ModalBody from './Body';

/* Styles */
import './style.scss';


const Modal = ({
	className, additionalClass, title, navigation, button, children
}) => {
	const hideModal = useModalStore(state => state.hideModal);
	const cantExitModal = useDomStore(state => state.cantExitModal);
	const modalBodyLocked = useDomStore(state => state.modalBodyLocked);
	const { pathname } = useLocation();
	const history = useHistory();

	const handleHideModal = () => {
		if (pathname.includes('/inventory/products/')) {
			history.push('/inventory/products');
		}

		hideModal();
	};

	return (
		<div className={`modal-component ${className} ${additionalClass}`}>
			<div className="overlay" onClick={() => cantExitModal || modalBodyLocked ? null : handleHideModal()} role="button" tabIndex={0} />
			<div className={`modal-component-wrapper ${modalBodyLocked ? 'disabled' : ''}`}>
				<ModalHeader title={title} navigation={navigation} button={button} />
				<ModalBody className={className}>{children}</ModalBody>
			</div>
		</div>
	);
};

Modal.propTypes = {
	title: PropTypes.string,
	children: PropTypes.node.isRequired,
	className: PropTypes.string,
	additionalClass: PropTypes.string,
	navigation: PropTypes.shape({
		icon: PropTypes.string,
		action: PropTypes.func
	}),
	button: PropTypes.shape({
		label: PropTypes.string,
		action: PropTypes.func,
		theme: PropTypes.string
	})
};

Modal.defaultProps = {
	title: null,
	className: '',
	additionalClass: '',
	navigation: PropTypes.shape({
		icon: null,
		action: null
	}),
	button: PropTypes.shape({
		label: '',
		action: null,
		theme: null
	})
};

export default Modal;
